import { render, staticRenderFns } from "./LoadPOS.vue?vue&type=template&id=0e3825da&lang=pug"
import script from "./LoadPOS.vue?vue&type=script&lang=js"
export * from "./LoadPOS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports